import * as Sentry from '@sentry/browser';
import Vue from 'vue';

/**
 * @brief initialise Sentry et configure le scope pour que l'utilisateur soit renseigné
 * */
export const sentryInit = function () {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Sentry.Integrations.Vue({Vue})],
    environment: process.env.NODE_ENV,
    beforeSend (event) {
      console.log(event);
      return event;
    }
  });

  if (localStorage.getItem('auth')) {
    const user = {};
    let name = JSON.parse(localStorage.getItem('auth')).user.name;
    let id = JSON.parse(localStorage.getItem('auth')).user.id;
    if (id) user.id = id;
    if (name) user.name = name;
    Sentry.configureScope(scope => {
      scope.setUser(user);
    });
  }
};

/**
 * @brief Configure le scope global de Sentry pour que l'utilisateur soit renseigné
 * @param user : Object - l'utilisateur
 * */
export const setUser = function (user) {
  const sentryUser = {...user};
  sentryUser.username = sentryUser.name;
  delete sentryUser.name;
  Sentry.configureScope(scope => {
    scope.setUser(user);
  });
};

/**
 * @brief Configure le scope global de Sentry pour que l'utilisateur soit supprimé
 * */
export const deleteUser = function () {
  Sentry.configureScope(scope => {
    scope.setUser({});
  });
};

/**
 * @brief supprime le scope
 * */
export const ResetScope = function () {
  Sentry.configureScope(scope => {
    scope.clear();
  });
};

/**
 @brief transmet l'exeption à Sentry avec de l'information en option et les infos utilisateurs si elles existent
 @param exception : Exception - l'exeption levée
 @param tags : Object - Tags clef - valeurs
 @param component : String - Le nom du composant ou du fichier en cours
 @param method : String - Le nom de la méthode qui ou l'exception est levée
 */
export const captureExceptionWithTags = function (exception, tags, component, method) {
  Sentry.withScope(scope => {
    Object.keys(tags).forEach(key => {
      scope.setTag(key, tags[key]);
    });
    if (component) scope.setTag('component', component);
    if (method) scope.setTag('method', method);
    Sentry.captureException(exception);
  });
};



// WEBPACK FOOTER //
// ./src/tools/sentry.js